import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Check = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M9.00016 16.6213L4.83016 12.4513L3.41016 13.8613L9.00016 19.4513L21.0002 7.45126L19.5902 6.04126L9.00016 16.6213Z"
    />
  </svg>
);
